import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';

import history from './helpers/history';
import * as numberFormatter from '@alphapoint/apex-web/lib/helpers/numberFormatter';
import initAPEXWebActions from '@alphapoint/apex-web/lib/helpers/apexWebActions';
import { ThemeProvider } from '@alphapoint/apex-web/lib/components/Theme/ThemeContext';
import { unregister } from './registerServiceWorker';
import config from './config';

import './styles/base/Fonts.css';
import './styles/base/Base.css';
import './styles/theme/variables.css';
import './styles/components/common/Divider.css';
import './styles/layout/Table.css';
import './styles/layout/app.css';
import './styles/components/common/index.css';
import App from './App';
import store from './redux/store';
import './translations/i18n';

if (config.global.theme) {
  window.document.documentElement.setAttribute('data-theme', config.global.theme);
}

if (process.env.NODE_ENV === 'development') {
  document.title = 'LOCAL APEX Trading';
}

initAPEXWebActions();

numberFormatter.init({
  locale: config.global.locale,
  getDecimalPlaces: () => store.getState().product.decimalPlaces,
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <ThemeProvider>
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  </ThemeProvider>,
);

unregister();
